export const TAG_MANAGEMENT_PREFIX = 'TAG-MANAGEMENT-PREFIX_';

export const SEARCH_REFRESH = TAG_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';

export const UPLOAD_LOGO_SUCCESS = TAG_MANAGEMENT_PREFIX + 'UPLOAD_LOGO_SUCCESS';